module.exports = {

  title: 'Train Admin',

  /**
   * @type {boolean} true | false
   * @description Whether fix the header
   */
  fixedHeader: false,

  /**
   * @type {boolean} true | false
   * @description Whether show the logo in sidebar
   */
  sidebarLogo: false,
  tagsView: true,
  currentLocale: navigator.language.substring(0, 2) === "zh" ? "zh" : "en"
}
